
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sitemapindex.xml",
      function () {
        return require("private-next-pages/sitemapindex.xml.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sitemapindex.xml"])
      });
    }
  